<template>
    <div>
        <div class="searchContent" id="search">
            <div class="p_select select_day" >
                <div class="search_label">查询日期</div>
                <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
                    <el-date-picker
                            v-model="checkDay"
                            type="date"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerDayOptions"
                            prefix-icon="''"
                            class="datepicker"
                            @change="getListData"
                            placeholder="选择开始日期">
                    </el-date-picker>
                    <i class="el-icon-date" ref="iconDateStart"></i>
                </div>
            </div>
            <div class="p_select">
                <el-select v-model="saId" clearable filterable placeholder="请选择服务顾问" @change="getListData">
                    <el-option
                            v-for="item in orginUserArr"
                            :key="item.saId"
                            :label="item.saName"
                            :value="item.saId"
                    ></el-option>
                </el-select>
            </div>
            <div class="p_select" >
                <a class="search_btn" @click="getListData">查询</a>
                <a   class="add_btn" @click="downloadListData('#efficiencyList')">导出</a>
            </div>
        </div>
        <div class="list_content">
            <el-table id="efficiencyList" :data="efficiencyList" style="width: 100%;padding-left: 12px;" :height="winHeight" :header-cell-style="getHeaderStyle" :cell-style="setRowStyle" header-cell-class-name="table_header">

                <el-table-column prop="dossierId" label="档案ID"></el-table-column>
                <el-table-column prop="carNumber" label="车牌"></el-table-column>
                <el-table-column prop="saName" label="服务顾问"></el-table-column>
                <!--<el-table-column prop="teamName" label="班组"></el-table-column>-->
                <el-table-column prop="preCheckStartTime" label="车辆建档时间"></el-table-column>
                <el-table-column prop="preCheckEndTime" label="检测完成时间"></el-table-column>
                <el-table-column prop="preCheckTime" label="检测耗时"></el-table-column>
                <el-table-column prop="requestTime" label="SA打开报告时间"></el-table-column>
                <el-table-column prop="viewReportTime" label="耗时"></el-table-column>

            </el-table>

        </div>


    </div>


</template>

<script>
  import net from "../../assets/js/public";
  import moment from "moment";
  import XLSX from "xlsx";
  import FileSaver from "file-saver";
  import Vue from 'vue'
  export default {
    data() {
      return {

        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
          }
        },
        checkDay:'',
        efficiencyList:[],
        winHeight:'200',
        teamList:[],
        teamId:'',
        saId:'',
        orginUserArr:[],

        showCarDetailInfo: false,
        dossierDetailList:[],
      }
    },
    created() {
      let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      if (signInfo.orgId > 0) {
        this.orgId = signInfo.orgId
      }
      let obj = new Date();
      let month = obj.getMonth() + 1;
      let day = obj.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.checkDay = obj.getFullYear() + "-" + month + "-" + day;
      this.getListData()
      this.querySaList()
    },
    methods: {
      onMouseOver(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'none';
        }else {
          this.$refs.iconDateEnd.style.display = 'none';
        }
      },
      onMouseleave(item) {
        if(item == 'start'){
          this.$refs.iconDateStart.style.display = 'block';
        }else {
          this.$refs.iconDateEnd.style.display = 'block';
        }
      },
      getHeaderStyle() {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      setRowStyle(row, column, rowIndex, columnIndex) {
        return 'font-family: PingFang SC;font-style: normal;color: #0D0E12;font-weight: 500;font-size: 14px;'
      },
      // 获取SA
      querySaList() {
        net.request("admin/manage/report/getSAByOrg", "post").then(res => {
          if (res.code === 0) {
            this.orginUserArr = res.data;
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        });
      },
      getListData() {
        if (this.checkDay == '' || this.checkDay == null) {
          net.message(this, '请选择查询日期', "warning");
          return
        }
        const params = {
          checkDay: this.checkDay,
          saId: this.saId || null,
        }
        net.request("admin/manage/construction/queryFrontBoard", "post", params).then(res => {
          if (res.code === 0) {
            net.message(this, res.msg, "success");
            let {data} = res
            data.forEach(item => {
              item.preCheckTime = item.preCheckStartTime && item.preCheckEndTime ?  this.calcDateDiff(item.preCheckStartTime, item.preCheckEndTime) : '-'
              item.viewReportTime = item.requestTime && item.preCheckEndTime ?  this.calcDateDiff(item.preCheckEndTime, item.requestTime*1) : '-'

              item.preCheckStartTime = item.preCheckStartTime ? moment(item.preCheckStartTime).format('YYYY-MM-DD HH:mm') :'-'
              item.preCheckEndTime = item.preCheckEndTime ? moment(item.preCheckEndTime).format('YYYY-MM-DD HH:mm') :'-'
              item.requestTime = item.requestTime ? moment(item.requestTime*1).format('YYYY-MM-DD HH:mm') :'-'


            })

            this.efficiencyList = data


            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
            this.winHeight = windiwHight - 170
          } else {
            net.message(this, res.msg, "warning");
          }
        });

      },
      //详情
      queryBoardDetail(row){
        const params = {
          dossierId: row.dossierId
        }
        net.request("admin/manage/construction/queryBoardDetail", "post", params).then(res => {
          if(res.code === 0){
            let data = res.data
            this.dossierDetailList = data
            this.showCarDetailInfo = true
          }
        })
      },


      //监听键盘Esc按键事件
      handleKeyup(event){
        let signInfo = JSON.parse(sessionStorage.getItem("showInfo"));
        let self = this;
        const e = event || window.event || arguments.callee.caller.arguments[0]
        if(!e) return
        if (e.keyCode == 27) {
          let routeNmae = self.$route.name
          if(routeNmae != 'OperationDataStatistics' && signInfo.active_tab == '3'){
            e.stopImmediatePropagation();
            self.$router.replace({ name: 'OperationDataStatistics' })
          }
        }
      },

      //计算两个时间之间的时间差 多少天时分秒
      calcDateDiff(date1, date2) {
        if(date1 > date2){
          return '-'
        }
        const newDate1 = moment(date1)
        const newDate2 = moment(date2)
        const diff = Math.abs(newDate1.diff(newDate2, 'minute'))
        // 一天的分钟
        const OneDay = 60 * 24
        // 一小时的分钟
        const OneHour = 60
        if (diff >= OneDay) {
          // 超过一天
          let day = Math.floor(diff / OneDay)
          let hour = Math.floor((diff - day * OneDay) / 60)
          let min = diff % 60
          return `${day}天${hour}小时${min}分`
        }

        if (diff >= OneHour) {
          // 超过一个小时，不足一天
          let hour = Math.floor(diff / 60)
          let min = diff % 60
          return `${hour}小时${min}分`
        }
        if (diff < OneHour) {
          let min = diff % 60
          return `${min}分`
        }
      },


      // 导出
      downloadListData(nodeId){
        var wb = XLSX.utils.table_to_book(document.querySelector(nodeId));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            "车间效率管理.xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
        }
      },



    },
    mounted() {
      window.addEventListener('keyup',this.handleKeyup)
    },
    beforeDestroy() {
      window.removeEventListener('keyup',this.handleKeyup)
    }
  };
</script>




<style lang='less' scoped>

    .searchContent {
        background: #fff;
        margin: 24px 0px 0 24px;
        padding-top: 24px;
        .p_select {
            display: flex;
            padding: 0 0 12px 12px;
            font-size: 12px;
            float: left;
            .search_label{
                font-family: 'PingFang SC';
                font-style: normal;
                margin-right: 12px;
                font-weight: 500;
                font-size: 14px;
                line-height: 40px;
                color: #787E86;
                white-space:nowrap
            }

            .el-input , .el-select{
                width: 160px;
            }
        }

        .search_btn {
            width: 76px;
            height: 38px;
            line-height: 38px;
            background: #2B54FC;
            box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
            border-radius: 4px;
            color: #FFFFFF;
            font-size: 14px;
        }
        .add_btn {
            width: 76px;
            height: 36px;
            margin-left: 10px;
            line-height: 36px;
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #2B54FC;
            border-radius: 4px;
            font-size: 14px;
            color: #2B54FC;
        }
    }
    .list_content {
        margin-left: 24px;
        background: #fff;
        padding-right: 12px;
    }

    .pagination {
        position: relative;
        margin-top: 10px;
        height: 36px;

        .el-pagination {
            position: absolute;
            right: 24px;


        }
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #009688;
    }

    .select_box {
        text-align: left;
        margin-bottom: 10px;

        .select_title {
            display: inline-block;
            width: 100px;
            text-align: right;
            margin-right: 20px;
        }
    }

    .el-image__inner {
        width: 32px;
        line-height: 1;
        text-align: center;
        vertical-align: bottom;
    }
    /deep/ .table_header {
        background: #F3F7FB !important;
        color: #364556;
    }

    .el-table__footer-wrapper, .el-table__header-wrapper {
        margin-left: 24px;
        height: 48px;

    }
    .el-table--scrollable-y .el-table__body-wrapper {
        margin-left: 24px;
    }


</style>
